// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3_0Dn","label":"LabeledBox_label__1IWJZ"};